const IMPORTS_ROUTES = {
  path: '/imports',
  component: () => import('@/pages/Imports/ImportsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'imports.index',
      component: () => import('@/pages/Imports/ImportsPage.vue'),
    },
    {
      path: ':id/show',
      name: 'imports.show',
      component: () => import('@/pages/Imports/ImportShowPage.vue'),
    },
  ],
};

export default IMPORTS_ROUTES;
